import React from 'react';
import CheckoutPlaidOAuthContainer from 'spa/containers/Checkout/V2/CheckoutPlaidOAuthContainer';

const CheckoutPlaidOAuthPage = () => <CheckoutPlaidOAuthContainer />;

export default CheckoutPlaidOAuthPage;
